import { useTranslations } from '@vocab/react';
import { Actions, Button, Dialog, Text } from 'braid-design-system';
import { useId } from 'react';

import translations from './.vocab';

interface Props {
  name?: string;
  onAbort: () => void;
  onConfirm: () => void;
}

export function DiscardDialog({ name = 'generic', onAbort, onConfirm }: Props) {
  const { t } = useTranslations(translations);
  const id = useId();

  return (
    <Dialog
      id={id}
      data={{ automation: `${name}-discard-dialog` }}
      title={t('Discard changes')}
      open
      onClose={onAbort}
      closeLabel={t('Close')}
      width="xsmall"
    >
      <Text>{t('Are you sure you want to leave without saving?')}</Text>
      <Actions>
        <Button
          data={{ automation: `${name}-discard-dialog-button` }}
          tone="critical"
          variant="ghost"
          onClick={onConfirm}
        >
          {t('Discard')}
        </Button>
        <Button
          data={{ automation: `${name}-cancel-dialog-button` }}
          tone="formAccent"
          variant="transparent"
          onClick={onAbort}
        >
          {t('Cancel')}
        </Button>
      </Actions>
    </Dialog>
  );
}
